export default "__VITE_ASSET__P8x6cGow__"